import {React, confirmAlert} from 'external/react'

export default function confirmDialog (props) {
  const {onConfirm, children, translate, className} = props
  return confirmAlert({
    customUI: ({onClose}) => {
      return (
        <div className={`${className} confirm-dialog`}>
          <div className="message">
            {children}
          </div>
          <div className="buttons">
            <div
              className="yes button"
              onClick={() => {
                onClose()
                onConfirm()
              }}
            >
              {translate('yes_label')}
            </div>
            <div className="no button" onClick={onClose}>
              {translate('no_label')}
            </div>
          </div>
        </div>
      )
    }
  })
}
